module.exports = __webpack_public_path__ + "static/js/mint-worker-altar.3f09468c.chunk.worker.js"